import { Card, CardBody, Col, Row } from "reactstrap";
import InlineCheckboxRadio from "./InlineCheckboxRadio";
import InlineSwitches from "./InlineSwitches";
import { InlineInputTypesTitle } from "../../../../../../constants";
import { InlineInputTypesSubTitle } from "../../../../../../data/formsAndTable/forms/FormControls";
import CommonCardHeader from "../../../../../../coreComponents/CommonCardHeader";

const InlineInputTypes = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={InlineInputTypesTitle} span={InlineInputTypesSubTitle} />
        <CardBody>
          <Row className="g-3">
            <InlineCheckboxRadio />
            <InlineSwitches />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
export default InlineInputTypes;
